import { render } from "./VolumesChart.vue?vue&type=template&id=349affea"
import script from "./VolumesChart.vue?vue&type=script&lang=js"
export * from "./VolumesChart.vue?vue&type=script&lang=js"
script.render = render

export default script